// extracted by css-extract-rspack-plugin
export default {"highlightedText":"highlighted-text-module__highlightedText__cKrVO"};